import { Table, TableBody, TableHead, TablePagination, TableRow } from '@material-ui/core';
import TableCell from '../../../../../../../../components/TableCell';
import React, { FC } from 'react';
import { GetHistoryResponse } from '../interfaces/History';
import moment from 'moment';
import ReadMore from 'src/components/ReadMore';

interface Props {
  history: GetHistoryResponse;
  onLimitChange: (limit: number) => void;
  onPageChange: (page: number) => void;
  page: number;
  limit: number;
}

const HistoryTable: FC<Props> = ({ history, page, limit, onLimitChange, onPageChange }) => {
  if (history.items.length <= 0) {
    return <div>Historique vide</div>;
  }

  return (
    <>
      <Table size='small'>
        <TableHead>
          <TableRow>
            <TableCell>Date</TableCell>
            <TableCell>Employé</TableCell>
            <TableCell>Valeur</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {history.items.map((event, key) => (
            <TableRow key={key}>
              <TableCell>{moment(event.createdDate).format('DD\u00A0MMMM\u00A0YYYY HH:mm')}</TableCell>
              <TableCell>
                {event.initiator.firstname} {event.initiator.lastname}
              </TableCell>
              <TableCell>
                <ReadMore text={event.value} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <TablePagination
        rowsPerPageOptions={[5, 10, 15]}
        count={history.total}
        component='div'
        rowsPerPage={limit}
        page={page}
        onPageChange={(event, page) => onPageChange(page)}
        onRowsPerPageChange={(event) => onLimitChange(parseInt(event.target.value, 10))}
        labelRowsPerPage='Ligne par page:'
        labelDisplayedRows={({ from, to, count }) => `${from}-${to} sur ${count}`}
      />
    </>
  );
};

export default HistoryTable;
